import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AllModalBox, BagCost, BagOldCost, ButtonWrap, CancelButton, Distance, IconBack, IconBag, IconBasket, IconBattery, IconCellular, IconDirect, IconHeart, IconShare, IconWarn, IconWifi, Img, IphoneIconsBox, ModalBox, ModalTitle, NoButton, PreviewBagsCount, PreviewBagsImg, PreviewBagsName, PreviewBottomBox, PreviewBox, PreviewButton, PreviewCategory, PreviewCategoryItem, PreviewDesc, PreviewDescLabel, PreviewDescName, PreviewImgBottomBox, PreviewImgBox, PreviewImgMiddleBox, PreviewImgTopBox, PreviewInfoBox, PreviewInfoRow, PreviewInfoSubBox, PreviewInfoSubRow, PreviewLogoBox, PreviewLogoImg, PreviewPointAddress, PreviewPointBox, PreviewPointName, SaveButton, ShareBox, Text, TimeS, Times, Title, WrapButton, YesButton } from './BagModal.styled';
import BagShopUpdate from './BagShopUpdate/BagShopUpdate';
import BagTimeUpdate from './BagTimeUpdate/BagTimeUpdate';
import { daysOfWeek, daysOfWeek1, formatDateTimeRange } from 'utils/function';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../redux/auth/selectors';
import PreviewBoxS from './PreviewBox/PreviewBox';
import Image from '../../../images/deletion.png'
import { useCalculateBagMutation, useDeleteAllBagMutation, useDeleteBagMutation, useEditBagDatesMutation, useEditBagMutation, useEditBagShopMutation } from '../../../redux/bags/bagsApi';
import RepeatUpdate from './RepeatUpdate';
import { showErrorToast, showWarningToast } from 'utils/showToast';
dayjs.extend(utc);
dayjs.extend(timezone);
const kyivTimeZone = 'Europe/Kyiv';

const BagModal = ({ onClose, bag, title, shopsData, type, pointd, nqe = false }) => {
  
  const user = useSelector(selectUser);
  const [editBagShop, { isLoading: isLoadingShopE }] = useEditBagShopMutation();
  const [editBagDates, { isLoading: isLoadingDates }] = useEditBagDatesMutation();
  const [editBag, { isLoading: isLoadingBag }] = useEditBagMutation();
  const [deleteBag, { isLoading: isLoadingDelete }] = useDeleteBagMutation();
  const [deleteAllBag, { isLoading: isLoadingDeleteAll }] = useDeleteAllBagMutation();
  const [shopId, setShopId] = useState(bag?.shop?.id);
  const [point, setPoint] = useState(pointd);
  const [calculateBag, { isLoading: isLoading1 }] = useCalculateBagMutation();
  const [startDate, setStartDate] = useState(dayjs(bag?.datetime_from).tz(kyivTimeZone).format('DD.MM.YYYY'));

  const [dayFrom, setDayFrom] = useState(bag?.datetime_from);
  const [dayTo, setDayTo] = useState(bag?.datetime_to);

  const today = dayjs();
  let temparray = []
  const currentDayOfMonth = today.date();
  const nextMonthDate = today.add(1, 'month').format('YYYY-MM-DD');
  if (bag?.schedule?.period === 'weekly') {
    temparray = Object.keys(daysOfWeek).map((day) => {

      if (bag?.schedule[day]) {

        return daysOfWeek1[day];
      }
    }).filter(day => !!day);


  }
  const [isAutomation, setIsAutomation] = useState(bag?.schedule ? true : false);
  const [arrayErrors, setArrayErrors] = useState({
    nameErr: false,
    descErr: false,
    categErr: false,
    costErr: false,
    timeErr: false,

  });
  const [startDate1, setStartDate1] = useState(bag?.schedule?.start);
  const [stopAfter, setStopAfter] = useState(bag?.schedule?.repeating_count ? bag?.schedule?.repeating_count : 1);
  const [repeatSchedule, setRepeatSchedule] = useState(bag?.schedule?.period);
  const [selectDaily, setSelectDaily] = useState('1');
  const [selectedDays, setSelectedDays] = useState(bag?.schedule?.period === 'weekly' ? temparray : []);
  const [dayOfMonth, setDayOfMonth] = useState(currentDayOfMonth);
  const [stopDate, setStopDate] = useState(bag?.schedule?.end ? bag?.schedule?.end : nextMonthDate);
  const [stopCondition, setStopCondition] = useState(bag?.schedule?.repeating_count ? 'after' : bag?.schedule?.end ? 'date' : 'never');
  const [calculatedStart, setCalculatedStart] = useState("");
  const [deliveryDay, setDeliveryDay] = useState(dayjs(bag?.datetime_from).tz(kyivTimeZone).format("YYYY-MM-DD") === dayjs().tz(kyivTimeZone).format("YYYY-MM-DD") ? "today" :
    dayjs(bag?.datetime_from).tz(kyivTimeZone).format("YYYY-MM-DD") === dayjs().tz(kyivTimeZone).add(1, 'day').format("YYYY-MM-DD") ? "tomorrow" :
      "other");
  
  const [firstTimeInitial, setFirstTimeInitial] = useState(dayjs(bag?.datetime_from).tz(kyivTimeZone));
  const [secondTimeInitial, setSecondTimeInitial] = useState(dayjs(bag?.datetime_to).tz(kyivTimeZone));
    console.log('Час кошику з firstTimeInitial :>> ', firstTimeInitial);
    console.log('Час кошику до secondTimeInitial :>> ', secondTimeInitial);
  

  useEffect(() => {
    const fetchData = async () => {
      let dataCalc = {
        start: dayjs(startDate1).format('YYYY-MM-DD'),
        period: repeatSchedule,
        from: dayjs(bag?.datetime_from).format("HH:mm:ss"),
        to: dayjs(bag?.datetime_to).format("HH:mm:ss"),
      };

      const daysMapping = {
        'Понеділок': 'mo',
        'Вівторок': 'tu',
        'Середа': 'we',
        'Четвер': 'th',
        'Пʼятниця': 'fr',
        'Субота': 'sa',
        'Неділя': 'su'
      };

      if (repeatSchedule === "daily") {
        dataCalc = { ...dataCalc, day_repeat: parseInt(selectDaily) };
      } else if (repeatSchedule === "monthly") {
        dataCalc = { ...dataCalc, day_of_month: dayOfMonth };
      } else {
        selectedDays.forEach(day => {
          const shortDay = daysMapping[day];
          if (shortDay) {
            dataCalc[shortDay] = true;
          }
        });
      }

      // console.log('dataCalc :>> ', dataCalc);

      if (isAutomation) {
        try {
          const response = await calculateBag(dataCalc);

          if (response && response.data) {

            // console.log('Отримані дані:', response.data);
            setCalculatedStart(dayjs(response.data.calculated_start).format('YYYY-MM-DD'));
          } else setCalculatedStart("");
        } catch (error) {
          // console.error('Помилка під час отримання відповіді:', error);
          setCalculatedStart("");
        }
      }
    };

    fetchData();
  }, [calculateBag, bag, repeatSchedule, startDate, dayOfMonth, selectedDays, selectDaily, isAutomation]);





  const handlePointChange = (event) => {
    const selectedPoint = event;
    console.log('event :>> ', event);
  
    console.log('object :>> ', shopsData);
    // console.log('shopsData :>> ', shopsData);
    const selectPointObj = shopsData?.find(item => `${item.name} (${item.address})` === selectedPoint)
    // console.log('selectPoinObj :>> ', selectPointObj);
    if (!selectPointObj.cash_register_type) showWarningToast("Для даної точки видачі не вказані дані ПРРО. Фіскалізація продажу не відбудеться")
    setPoint(selectedPoint);
    setShopId(selectPointObj.id)
  }
  const handleEdit = async () => {
    const daysMapping = {
      'Понеділок': 'mo',
      'Вівторок': 'tu',
      'Середа': 'we',
      'Четвер': 'th',
      'Пʼятниця': 'fr',
      'Субота': 'sa',
      'Неділя': 'su',
    };

    try {
      if (type === 'shop') {
        const response = await editBagShop({ id: bag?.id, shop_id: shopId });
        if (!response || response.error) {
          throw response;
        }
        onClose();
      } else if (type === 'time') {
        console.log('Початок дії кнопки зберегти для часу ');
        console.log('Змінений час з dayFrom)123>> ',dayFrom);
        console.log('Змінений час до dayTo)123>> ', dayTo);
        //  const response = await editBagDates({ id: bag?.id, datetime_from: dayFrom, datetime_to: dayTo });
        // const payload = {
        //   id: bag.id,
        //   datetime_from: dayFrom.toDate().toISOString(),    // завжди "YYYY-MM-DDTHH:mm:ss.sssZ"
        //   datetime_to: dayTo instanceof Date
        //     ? dayTo.toISOString()
        //     : dayjs(dayTo).toDate().toISOString()
        // };



        const payload = {
          id: bag.id,
          datetime_from: dayjs(dayFrom).toISOString(),
          datetime_to: dayjs(dayTo).toISOString()
        };
   
        console.log('Payload for iOS/Android:', payload);

        const response = await editBagDates(payload).unwrap();
        
        
        
        if (!response || response.error  ) {
          throw response;
        }
        onClose();
      } else
        if (type === 'scheldule') {
        let repeatData = {
          period: repeatSchedule,
          start: calculatedStart,
        };

        if (stopCondition === 'date') {
          repeatData = {
            ...repeatData,
            end: dayjs(stopDate).format('YYYY-MM-DD'),
          };
        }
        if (stopCondition === 'after') {
          repeatData = {
            ...repeatData,
            repeating_count: stopAfter,
          };
        }

        if (repeatSchedule === 'daily') {
          repeatData = {
            ...repeatData,
            day_repeat: parseInt(selectDaily),
          };
        }
        if (repeatSchedule === 'weekly') {
          selectedDays.forEach((day) => {
            const shortDay = daysMapping[day];
            if (shortDay) {
              repeatData[shortDay] = true;
            }
          });
        }
        if (repeatSchedule === 'monthly') {
          repeatData = {
            ...repeatData,
            day_of_month: parseInt(dayOfMonth),
          };
        }

        console.log('repeatData :>> ', repeatData);
        const response = await editBag({ id: bag?.id, datetime_from: bag?.datetime_from, datetime_to: bag?.datetime_to, ...repeatData })
        if (!response || response.error) {
          throw response;
        }
        onClose();
      }
    } catch (error) {
      console.log('eror23r :>> ', error);

      const message = error?.error?.data?.message;
      const errors = error?.error?.data?.details?.errors;

      if (errors && typeof errors === 'object') {
        Object.entries(errors).forEach(([field, messages]) => {
          messages.forEach((msg) => {
            showErrorToast(msg); // Показуємо кожну помилку окремо
          });
        });
      } else if (message) {
        console.log('Повідомлення з беку  message:>> ', message);
        showErrorToast(message);
      } else {
        showErrorToast('Сталася помилка. Спробуйте пізніше.');
        console.log('Повідомлення коду error>> ', error);
        showErrorToast(error);
      }
    }
    console.log('Кінець дії кнопки зберегти для часу ');
  };
  const handleDelete = async () => {

    try {

      if (type === 'deleteall')
        await deleteAllBag(bag.id).unwrap()
      else { await deleteBag(bag.id).unwrap() }
      onClose();
    } catch (error) {

    }

  }




  const isDelete = type === 'delete' || type === 'deletereg' || type === "deleteall";

  return (
    <Modal onClose={onClose} nqe={nqe}>
      {!isDelete && <ModalTitle>{title}</ModalTitle>}
      {type === 'preview' ? (<PreviewBoxS bag={bag} user={user} />) :
        isDelete ? <AllModalBox> <Img src={Image} alt="Видалити" />
          <Title>{title}</Title>
          <Text>{
            type === 'delete' ? 'Ви впевнені, що хочете видалити цей диво-кошик? Якщо він вже був заброньований, то ці бронювання будуть скасовані.' :
              type === 'deleteall' ? 'Ви впевнені, що хочете видалити всі подальші  диво-кошики? Якщо якісь з них вже були заброньовані, ці бронювання будуть скасовані.' : 'Ви впевнені, що хочете видалити цей регулярний диво-кошик? Якщо ви це зробите, то кошики за цим шаблоном більше не будуть створюватись.'
          }</Text>  <WrapButton>
            <NoButton onClick={onClose}>Ні, не видаляти</NoButton>
            <YesButton
              onClick={handleDelete}>Так, видалити</YesButton>

          </WrapButton> </AllModalBox> : <><ModalBox>
            {type === 'shop' && <BagShopUpdate point={point} shopsData={shopsData} setPoint={handlePointChange} />}
            {type === 'time' && <BagTimeUpdate startDate={startDate}
              setStartDate={setStartDate}
              dayFrom={dayFrom}
              dayTo={dayTo}
              setDayFrom={setDayFrom}
              setDayTo={setDayTo} deliveryDay={deliveryDay} setDeliveryDay={setDeliveryDay} firstTimeInitial={firstTimeInitial} secondTimeInitial={secondTimeInitial} setFirstTimeInitial={setFirstTimeInitial} setSecondTimeInitial={setSecondTimeInitial} />}
            {type === 'scheldule' && <RepeatUpdate
              setIsAutomation={setIsAutomation}
              isAutomation={isAutomation}
              setArrayErrors={setArrayErrors}
              setStopAfter={setStopAfter}
              repeatSchedule={repeatSchedule}
              setRepeatSchedule={setRepeatSchedule}
              selectDaily={selectDaily}
              setSelectDaily={setSelectDaily}
              selectedDays={selectedDays}
              setSelectedDays={setSelectedDays}
              dayOfMonth={dayOfMonth}
              setDayOfMonth={setDayOfMonth}
              startDate={startDate1}
              setStartDate={setStartDate1}
              stopDate={stopDate}
              setStopDate={setStopDate}
              stopCondition={stopCondition}
              setStopCondition={setStopCondition}
              stopAfter={stopAfter}
              calculatedStart={calculatedStart}


            />}
          </ModalBox >

          <ButtonWrap>
            <CancelButton onClick={onClose}>Скасувати</CancelButton>
            <SaveButton onClick={handleEdit}>Зберегти</SaveButton>
          </ButtonWrap>
        </>}
    </Modal >
  );
};

export default BagModal;
